// Lazy loader for GramJS (`telegram`) so the heavy MTProto bundle is a separate
// chunk, fetched only on first login/enumeration/send (keeps initial load small).
//
// NOTE: we use GramJS, NOT the `teleproto` fork — teleproto ships only the Node
// TCP transport (PromisedNetSockets) and has no browser WebSocket transport, so
// connect() hangs forever in the browser. GramJS includes PromisedWebSockets and
// maps DCs to wss://{dc}.web.telegram.org/apiws.
import type { TelegramClient } from "telegram";
import { reloadForStaleChunk } from "../lib/chunkReload";

export interface TgModule {
  TelegramClient: typeof import("telegram").TelegramClient;
  StringSession: typeof import("telegram/sessions").StringSession;
  Api: typeof import("telegram").Api;
  errors: typeof import("telegram").errors;
  CustomFile: typeof import("telegram/client/uploads").CustomFile;
  returnBigInt: typeof import("telegram").helpers.returnBigInt;
  PromisedWebSockets: typeof import("telegram/extensions").PromisedWebSockets;
}

let cached: Promise<TgModule> | null = null;

export function loadTg(): Promise<TgModule> {
  if (!cached) {
    cached = (async () => {
      let core, sessions, uploads, extensions;
      try {
        [core, sessions, uploads, extensions] = await Promise.all([
          import("telegram"),
          import("telegram/sessions"),
          import("telegram/client/uploads"),
          import("telegram/extensions"),
        ]);
      } catch (e) {
        // stale-deploy chunk error: reload to fetch current chunks, then rethrow
        reloadForStaleChunk();
        cached = null;
        throw e;
      }
      return {
        TelegramClient: core.TelegramClient,
        StringSession: sessions.StringSession,
        Api: core.Api,
        errors: core.errors,
        CustomFile: uploads.CustomFile,
        returnBigInt: core.helpers.returnBigInt,
        PromisedWebSockets: extensions.PromisedWebSockets,
      };
    })();
  }
  return cached;
}

export type { TelegramClient };
